import React from 'react';
import { ImageIcon } from 'lucide-react';

export default function EmailHeaderBlock({ props, isSelected, onOpenContentPicker }) {
  return (
    <div style={{ padding: props.padding || '24px', backgroundColor: props.background_color || '#ffffff', textAlign: props.logo_alignment || 'center' }}>
      {props.logo_url ? (
        <img src={props.logo_url} alt={props.logo_alt || 'Logo'} style={{ width: props.logo_width || '150px', maxWidth: '100%', height: 'auto', display: 'inline-block' }} />
      ) : (
        <div className="inline-flex items-center gap-2 px-4 py-3 border border-dashed border-stone-200 rounded-lg text-xs text-stone-400">
          <ImageIcon className="w-4 h-4" />
          {isSelected ? (
            <button onClick={onOpenContentPicker} className="text-stone-600 hover:text-stone-900 underline">Add logo</button>
          ) : 'Logo'}
        </div>
      )}
      {props.preheader_text && (
        <p style={{ margin: props.logo_url ? '12px 0 0' : '0', fontSize: '12px', color: '#78716c', textAlign: 'center' }}>{props.preheader_text}</p>
      )}
    </div>
  );
}
